import type { SVGProps } from "react";

export function SlidersIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M2.66638 3.3337L6.66638 3.33354"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M8.66638 3.33354H13.333"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M10.6664 6.00021V10.0002"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M6.66638 1.33354V5.33354"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M7.99963 10.6669V14.6669"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M10.6664 8.00006L13.333 8.00019"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M2.66638 8.00033L8.66636 8.0002"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M7.99963 12.6669H13.333"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M2.66638 12.667L5.99971 12.6669"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  );
}
